import { useTranslation } from "react-i18next";
import { ToggleButtonGroup, StyledToggleButton } from "@plannel/components/ui/ToggleButton";
import { FS } from "@plannel/utils/font-util";

/*
 * DW 대시보드 공용 세그먼트 토글.
 * 라벨 i18n: 옵션 소문자 키로 번역(amt/qty/month/week 등, 기존 키). 키 없으면 옵션 원문 표시.
 * 값(value)은 옵션 문자열 그대로 유지 — 표시만 번역.
 */

// 세그먼트 토글(예: AMT/QTY). options=["AMT","QTY"], value=현재값, onChange(v).
export const SegToggle = ({ value, options, onChange }) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup size="small" exclusive value={value} onChange={(_e, v) => v && onChange(v)} sx={{ height: 20 }}>
      {options.map((o) => (
        <StyledToggleButton key={o} value={o}
          sx={{ px: 0.9, py: 0, fontSize: FS.CAPTION, lineHeight: 1.4, textTransform: "none", color: "text.secondary" }}>
          {t(o.toLowerCase(), { defaultValue: o })}
        </StyledToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

// Month/Week 버킷 토글 — Month 는 항상 표시, Week 는 weekAvailable 일 때만. 값은 소문자 month/week.
export const BucketToggle = ({ bucket, weekAvailable, onChange }) => (
  <SegToggle
    value={bucket === "week" ? "Week" : "Month"}
    options={weekAvailable ? ["Month", "Week"] : ["Month"]}
    onChange={(v) => onChange(v.toLowerCase())}
  />
);
